import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {Card} from 'antd';

import _ from 'lodash';

import * as actions from '../redux/actions/index';
import DataTable from "../components/DataTable";

class CountyTableCard extends Component {
  render() {
    return (
      <Card className="CountyTableCard" noHovering={true} loading={this.props.loading}>
        <h2 className="subtitle">
          {this.props.selectedCounty.name} County Tabular Health Dimensions By Year<br/>
          <svg width={14} height={8}><rect width={8} height={8} rx={4} ry={4} fill="#e00de0"></rect></svg>
          National Percentile Ranking for County Dimension and Year
        </h2>
        <DataTable
          data={this.props.data}
          percentiles={this.props.percentiles}
          dimensions={this.props.dimensions}
          national={this.props.nationalData}
          state={this.props.stateData}
          dimX={this.props.xField}
          dimY={this.props.yField}
          county={`${this.props.selectedCounty.name} ${this.props.selectedCounty.state}`}
        />
      </Card>
    );
  }
}

function mapStoreToProps(store, props) {
  const stateFips = _.get(store, ['states', 'selected', 'fips']);
  const stateData = _.get(store, ['states', 'dict', stateFips], {});
  const countyFips = _.get(store, ['counties', 'selected', 'fips']);
  const countyData = _.get(store, ['counties', 'dict', countyFips], {});
  const countyPerc = _.get(store, ['counties', 'percentileDict', countyFips], {});

  return {
    loading: store.states.loading || store.dimensions.loading,
    year: store.dimensions.year,
    selectedState: store.states.selected,
    selectedCounty: store.counties.selected,
    nationalData: store.states.averages,
    stateData: stateData,
    data: countyData,
    percentiles: countyPerc,
    dimensions: store.dimensions.fields,
    xField: store.dimensions.xField,
    yField: store.dimensions.yField
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch)
  }
}

export default connect(mapStoreToProps, mapDispatchToProps)(CountyTableCard);



// WEBPACK FOOTER //
// ./src/containers/CountyTableCard.js